import admin from '@/router/routes/route-admin'
import base from '@/router/routes/route-base'
import dossier from '@/router/routes/route-dossier'
import recherche from '@/router/routes/route-recherche'
import rapports from '@/router/routes/route-rapports'

export default [...admin, ...base, ...dossier, ...recherche, ...rapports]
